import { render, staticRenderFns } from "./VuesticDataTable.vue?vue&type=template&id=de546afc"
import script from "./VuesticDataTable.vue?vue&type=script&lang=js"
export * from "./VuesticDataTable.vue?vue&type=script&lang=js"
import style0 from "./VuesticDataTable.vue?vue&type=style&index=0&id=de546afc&prod&lang=scss"
import style1 from "./VuesticDataTable.vue?vue&type=style&index=1&id=de546afc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports